import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import * as moment from 'moment';
import Select from 'react-select';
import * as service from '../../services/service';

function ViewDeliveryChallans() {
    const [data, setData] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const [workOrderData, setWorkOrderData] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [workOrderId, setWorkOrderId] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const navigate = useNavigate();

    const getCustomers = () => {
        fetch(
            service.CUSTOMER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.customerId, label: item.customerName }));
                setCustomerData(data2);
            });
    };

    const getWorkOrders = (id) => {
        fetch(
            service.GET_PENDING_WORK_ORDER,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CustomerId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.workOrderId, label: item.jobNo }));
                setWorkOrderData(data2);
            });
    };

    const getDetails = (id) => {
        fetch(
            service.GET_DELIVERY_CHALLANS,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    WorkOrderId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const handleEdit = (id) => {
        navigate(`/printdeliverychallan/${id}`);
    }

    useEffect(() => {
        setLoading(true);
        getCustomers();
        setLoading(false);
    }, []);

    const customerChangeHandler = (ev) => {
        setCustomerId(ev);
        setWorkOrderId(null);
        getWorkOrders(ev.value);
        setData([]);
    }
    const workOrderChangeHandler = (ev) => {
        setWorkOrderId(ev);
        getDetails(ev.value);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {error
                ? <MDAlert color="warning" dismissible>{error}</MDAlert>
                : null
            }
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Delivery Challans
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table style={{ width: '50%' }}>
                                    <TableRow>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '50%' }}>
                                            <Select
                                                name="customer"
                                                options={customerData} placeholder="Select Customer"
                                                value={customerId}
                                                onChange={customerChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '50%' }}>
                                            <Select
                                                name="workorder"
                                                options={workOrderData} placeholder="Select Job Number"
                                                value={workOrderId}
                                                onChange={workOrderChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <br />
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Challan No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Challan Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Job No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Customer</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Sub Assembly</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Part</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Common Part</TableCell>
                                                {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Store'
                                                    || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Manager - Store'
                                                    || userDesignation === 'Sr Mgr - Store' || userDesignation === 'Asst Mgr - Marketing'
                                                    || userDesignation === 'Jr Mgr - Marketing' || userDesignation === 'Manager - Marketing'
                                                    || userDesignation === 'Sr Mgr - Marketing' || userDesignation === 'Bussiness Development and Operations' 
                                                    || userDesignation === 'Assistant - Store' ?
                                                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                    : null}
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.deliveryChallanId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.challanNo}</TableCell>
                                                        <TableCell>{moment(row.challanDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{row.workOrderNo}</TableCell>
                                                        <TableCell>{row.jobNo}</TableCell>
                                                        <TableCell>{row.customerName}</TableCell>
                                                        <TableCell>{row.product}</TableCell>
                                                        <TableCell>{row.subAssembly}</TableCell>
                                                        <TableCell>{row.part}</TableCell>
                                                        <TableCell>{row.commonPart}</TableCell>
                                                        {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Store'
                                                            || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Manager - Store'
                                                            || userDesignation === 'Sr Mgr - Store' || userDesignation === 'Asst Mgr - Marketing'
                                                            || userDesignation === 'Jr Mgr - Marketing' || userDesignation === 'Manager - Marketing'
                                                            || userDesignation === 'Sr Mgr - Marketing' || userDesignation === 'MD' 
                                                            || userDesignation === 'Assistant - Marketing' || userDesignation === 'Bussiness Development and Operations' 
                                                            || userDesignation === 'Assistant - Store' ?
                                                            <TableCell><MDButton onClick={() => handleEdit(row.deliveryChallanId)}>View</MDButton></TableCell>
                                                            : null}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default ViewDeliveryChallans;